export default "__VITE_ASSET__azQ821vV__"